/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-indent-props */

import React, { useContext, useEffect, useMemo, useState } from 'react';
import { CloudDownloadOutlined } from '@mui/icons-material';
import { Row, Col, FormGroup, Label, Card, CardBody, Input } from 'reactstrap';
import ClearIcon from '@mui/icons-material/Clear';
import { LoaderMini } from '~/components/Loaders';
import InputAutoSelect from '~/components/InputAutoSelect';
import { ExtratoContext } from '~/context/ExtratoContext';
import { TextClick } from '../FiltroExtratoCredito/styles';


// import { ExtratoContext } from '~/context/ExtratoContext';
// import { ButtonStyled } from './styles';

export function FiltroCredRevenda(props) {
	const { user, setFiltroStatus, filtroStatus, setFiltroPesquisa, setPagina, loadingRevendedores,
		downloadResumo } =
		props;

	const {
		revendaHierarquiaList,
		getHierarquiaByDoc
	} = useContext(ExtratoContext);

	const [inputValue, setInputValue] = useState('')
	const [timer, setTimer] = useState(null)

	useEffect(() => {
		if(revendaHierarquiaList.length === 0){
			getHierarquiaByDoc(user.dados.documento)
		}
	}, []);

	const handleChange = event => {
		setFiltroStatus(event.target.value);
		setPagina(1)
	};

	const inputChanged = e => {
		setPagina(1)
		setInputValue(e.target.value)
		clearTimeout(timer)

		const newTimer = setTimeout(() => {
			setFiltroPesquisa(e.target.value)
		}, 1000)

		setTimer(newTimer)
	}

	function handlerLimparFiltro() {
		setFiltroStatus('');
		setInputValue('');
		setFiltroPesquisa('');

		setPagina(1);
	}

	const options = useMemo(() =>[{"documento": "Todos","nome": ""}, ...revendaHierarquiaList], [revendaHierarquiaList]);
	const selectedValue = options.find(opt => opt?.nome === inputValue) || null;

	return (
		<Card
			style={{
				boxShadow: 'unset',
				borderRadius: '0px 18px 18px 18px',
			}}>
			<CardBody>
				<Row style={{ justifyContent: 'center' }} xs="12" md="12" lg="12">
					<Col xs="12" md="12" lg={user.dados.permissoes.view_credito_revenda ? 9 : 12}>
						<FormGroup>
						<Label style={{ fontWeight: 'bold' }}>{(user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor'  || user.dados.permissoes.manage_workshops) ? (user.dados.permissoes.view_farmacias ? 'Buscar farmácia' : 'Buscar revenda') : 'Buscar distribuidor'}</Label>
						{(user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' || user.dados.cargo.toLowerCase() === 'industria'  || user.dados.permissoes.manage_workshops)
							? (user.dados.permissoes.view_farmacias
								?
									<Input
										type="text"
										placeholder={user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' ? (user.dados.permissoes.view_farmacias ? 'Qual é a farmácia?' : 'Qual é a revenda?') : 'Qual o distribuidor ?'}
										value={inputValue}
										onChange={inputChanged}
										style={{borderRadius: "5px", height: '55px'}}
									/>
								:
									<>
										{revendaHierarquiaList.length > 0 ?
												<InputAutoSelect
													options={options}
													getOptionLabel={(item) => `${item?.documento  || ''}${item?.documento && item?.nome ? ' - ' : ''}${item?.nome  || ''}` || ''}
													isOptionEqualToValue={(option, valueSelect) => option?.documento === valueSelect}
													value={selectedValue}
													onChangeOption={(evt, select) => {
														inputChanged({target: {value: select?.nome}} || {target: {value: ''}})
													}}
												/>
											:
												<Input
													type="text"
													placeholder={(user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor'  || user.dados.permissoes.manage_workshops) ? (user.dados.permissoes.view_farmacias ? 'Qual é a farmácia?' : 'Qual é a revenda?') : 'Qual o distribuidor ?'}
													value={inputValue}
													onChange={inputChanged}
													style={{borderRadius: "5px", height: '55px'}}
												/>
										}
									</>
								)
						:
							<Input
								type="text"
								placeholder={user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' ? (user.dados.permissoes.view_farmacias ? 'Qual é a farmácia?' : 'Qual é a revenda?') : 'Qual o distribuidor ?'}
								value={inputValue}
								onChange={inputChanged}
								style={{borderRadius: "5px", height: '55px'}}
							/>
						}


						</FormGroup>
					</Col>
					{user.dados.permissoes.view_credito_revenda ?
						<Col xs="12" md="12" lg="3">
							<FormGroup>
								<Label style={{ fontWeight: 'bold' }}>Organizar por:</Label>
								<Input
									type="select"
									value={filtroStatus}
									onChange={handleChange}
									style={{borderRadius: "5px", height: '55px'}}
								>
									{user.dados.cargo.toLowerCase() === '' ?
										<>
											<option value="">
												Sem filtro
											</option>
											<option value="APROVADO">
												Autorizado
											</option>
											<option value="REPROVADO">
												Não Autorizado
											</option>
											<option value="PENDENTE">
												Pendente
											</option>

										</>
										:
										<>
											<option value="">
												Sem filtro
											</option>
											<option value="maior">
												Maior crédito
											</option>
											<option value="menor">
												Menor crédito
											</option>

										</>}
								</Input>
							</FormGroup>
						</Col> : <></>}
					<Col>
						<button
							style={{ all: 'unset', cursor: 'pointer', color: '#333333', float: 'right' }}
							type='button'
							onClick={() => handlerLimparFiltro()}>
							<ClearIcon style={{ color: '#0AD6EA' }} />
							{' '}
							Limpar Filtros
						</button>
						<TextClick
							style={{ all: 'unset', cursor: 'pointer', paddingRight: 10, color: '#333333', float: 'right' }}
							onClick={downloadResumo}
							tabIndex="0"
							role="button"
						>
							{loadingRevendedores &&
								<LoaderMini />
							}

							{loadingRevendedores === false &&
								<>
									<CloudDownloadOutlined className="mr-1" />
									Fazer Download
								</>
							}
						</TextClick>
					</Col>
				</Row>
			</CardBody>
		</Card>
	);
}
